import { ApiListRelationship, ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export enum SARStatus {
  Open = 'open',
  Pending = 'pending',
  Filed = 'filed', // deprecated, to be deleted once we migrate all SARs off :filed state
  FiledManually = 'filed_manually',
  FiledElectronically = 'filed_electronically',
  Accepted = 'accepted',
  AcceptedWithWarnings = 'accepted_with_warnings',
  Processed = 'processed',
  ProcessedWithWarnings = 'processed_with_warnings',
  Rejected = 'rejected',
  Archived = 'archived',
}

export const SAR_STATUS_LABEL_MAP: Record<SARStatus, string> = {
  [SARStatus.Open]: 'Open',
  [SARStatus.Pending]: 'Pending',
  [SARStatus.Filed]: 'Filed',
  [SARStatus.FiledManually]: 'Filed manually',
  [SARStatus.FiledElectronically]: 'Filed',
  [SARStatus.Accepted]: 'Accepted',
  [SARStatus.AcceptedWithWarnings]: 'Accepted with warnings',
  [SARStatus.Processed]: 'Processed',
  [SARStatus.ProcessedWithWarnings]: 'Processed with warnings',
  [SARStatus.Rejected]: 'Rejected',
  [SARStatus.Archived]: 'Archived',
};

export enum SARFilingType {
  InitialReport = 'initial_report',
  JointReport = 'joint_report',
  ContinuingActivityReport = 'continuing_activity_report',
  CorrectsAmendsPriorReport = 'corrects_amends_prior_report',
}

export type SARData = Record<string, unknown>;

export interface SARValidationErrors {
  'xml-schema-errors'?: string[];
  'json-schema-errors'?: string[];
}

export interface SARAttributes {
  name: string;
  status: SARStatus;
  'filing-type': SARFilingType;
  'bsa-id': string;
  data: SARData;
  'created-at'?: Iso8601DateString;
  'updated-at'?: Iso8601DateString;
  'filed-at'?: Iso8601DateString;
  'archived-at'?: Iso8601DateString;
  'decisioned-at'?: Iso8601DateString;
}

export interface SARRelationships {
  transactions: ApiListRelationship<ApiModel.Transaction>;
  transactionTypes: ApiListRelationship<ApiModel.TransactionType>;
  transactionStatuses: ApiListRelationship<ApiModel.TransactionStatus>;
  accounts: ApiListRelationship<ApiModel.Account>;
  accountTypes: ApiListRelationship<ApiModel.AccountType>;
  accountStatuses: ApiListRelationship<ApiModel.AccountStatus>;
  creator?: ApiRelationship<ApiModel.User>;
}

export type SAR = ApiResource<SARAttributes, SARRelationships, ApiModel.SAR>;
